export default class AnyButton {
    static get toolbox() {
        return {
            title: "Button",
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><rect x="9" y="9" width="18" height="18" rx="3" fill="black"/></svg>`
        };
    }

    static get sanitize() {
        return {
            buttons: {
                text: true,
                link: true
            }
        };
    }

    static get enableLineBreaks() {
        return false;
    }

    static get isReadOnlySupported() {
        return true;
    }

    constructor({ data, config, api, readOnly }) {
        this.api = api;
        this.readOnly = readOnly;

        this._data = {
            buttons: [],
            ...(data || {})
        };

        this.editingIndex = null;

        const _CSS = {
            baseClass: this.api.styles.block,
            inputHolder: "anyButtonContainer__inputHolder",
            input: "anyButtonContainer__input",
            inputText: "anyButtonContainer__input--text",
            inputLink: "anyButtonContainer__input--link",
            registButton: "anyButtonContainer__registerButton",
            anyButtonHolder: "anyButtonContainer__anyButtonHolder",
            btn: "anyButton__btn",
            btnColor: "anyButton__btn--default"
        };

        this.CSS = Object.assign(_CSS, config.css || {});
        this.linkValidation = config.linkValidation || this.defaultLinkValidation.bind(this);
        this.textValidation = config.textValidation || this.defaultTextValidation.bind(this);

        this.nodes = {};
    }

    render() {
        this.nodes.wrapper = this.make('div', this.CSS.baseClass);
        this.nodes.inputHolder = this.makeInputHolder();
        this.nodes.anyButtonHolder = this.make('div', [this.CSS.anyButtonHolder]);
        this.nodes.anyButtonHolder.style.display = 'flex';
        this.nodes.anyButtonHolder.style.flexWrap = 'wrap';
        this.nodes.anyButtonHolder.style.gap = '10px';

        this.nodes.wrapper.appendChild(this.nodes.inputHolder);
        this.nodes.wrapper.appendChild(this.nodes.anyButtonHolder);

        if (this._data.buttons?.length > 0) {
            this._data.buttons.forEach((btn, i) => {
                this.appendButton(btn.text, btn.link, i);
            });
        }

        return this.nodes.wrapper;
    }

    makeInputHolder() {
        const holder = this.make('div', this.CSS.inputHolder);

        this.nodes.textInput = this.make('div', [this.api.styles.input, this.CSS.input, this.CSS.inputText], {
            contentEditable: !this.readOnly,
        });
        this.nodes.textInput.dataset.placeholder = this.api.i18n.t('Button Text');

        this.nodes.linkInput = this.make('div', [this.api.styles.input, this.CSS.input, this.CSS.inputLink], {
            contentEditable: !this.readOnly,
        });
        this.nodes.linkInput.dataset.placeholder = this.api.i18n.t('Link Url');

        this.nodes.registButton = this.make('button', [this.api.styles.button, this.CSS.registButton]);
        this.nodes.registButton.type = 'button';
        this.nodes.registButton.textContent = 'Добави бутон';

        this.nodes.registButton.addEventListener('click', () => {
            const text = this.nodes.textInput.textContent.trim();
            const link = this.nodes.linkInput.textContent.trim();

            this.nodes.registButton.textContent = 'Добави бутон';

            if (!this.linkValidation(link) || !this.textValidation(text)) return;

            const buttonData = { text, link };

            if (this.editingIndex !== null) {
                this._data.buttons[this.editingIndex] = buttonData;
            } else {
                this._data.buttons.push(buttonData);
            }

            this.nodes.textInput.textContent = "";
            this.nodes.linkInput.textContent = "";

            this.editingIndex = null;
            this.highlightEditingButton(-1);

            // ⬇⬇⬇ ТУК СЕ ПРЕНАДИГРАВА ВСИЧКО – ОБНОВЯВА ИНТЕРФЕЙСА
            this.nodes.anyButtonHolder.innerHTML = '';
            this._data.buttons.forEach((btn, i) => this.appendButton(btn.text, btn.link, i));
        });

        holder.appendChild(this.nodes.textInput);
        holder.appendChild(this.nodes.linkInput);
        holder.appendChild(this.nodes.registButton);

        return holder;
    }

    appendButton(text, link, index) {
        const btnWrapper = this.make('div', ['anyButton__btn', this.CSS.btnColor]);
        btnWrapper.style.position = 'relative';
        btnWrapper.style.display = 'inline-flex';
        btnWrapper.style.alignItems = 'center';
        btnWrapper.style.paddingRight = '36px';

        const btn = this.make('a', [], {
            target: '_blank',
            rel: 'nofollow noreferrer noopener',
            href: link,
        });
        btn.textContent = text;
        btn.style.color = 'white';
        btn.style.marginRight = '10px';
        btn.style.textDecoration = 'none';

        const removeBtn = this.make('button', 'anyButton__remove');
        removeBtn.textContent = '×';
        removeBtn.style.position = 'absolute';
        removeBtn.style.right = '6px';
        removeBtn.style.top = '50%';
        removeBtn.style.transform = 'translateY(-50%)';
        removeBtn.style.background = 'transparent';
        removeBtn.style.border = 'none';
        removeBtn.style.color = 'white';
        removeBtn.style.cursor = 'pointer';

        const editBtn = this.make('button', 'anyButton__edit');
        editBtn.textContent = '✎';
        editBtn.title = 'Редактирай';
        editBtn.style.position = 'absolute';
        editBtn.style.right = '24px';
        editBtn.style.top = '50%';
        editBtn.style.transform = 'translateY(-50%)';
        editBtn.style.background = 'transparent';
        editBtn.style.border = 'none';
        editBtn.style.color = 'white';
        editBtn.style.cursor = 'pointer';

        editBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.editingIndex = index;
            this.nodes.textInput.textContent = text;
            this.nodes.linkInput.textContent = link;
            this.nodes.registButton.textContent = "Редактирай";
            this.highlightEditingButton(index);
        });

        removeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this._data.buttons.splice(index, 1);
            this.nodes.anyButtonHolder.innerHTML = '';
            this._data.buttons.forEach((btn, i) => this.appendButton(btn.text, btn.link, i));
        });

        btnWrapper.appendChild(btn);
        btnWrapper.appendChild(editBtn);
        btnWrapper.appendChild(removeBtn);
        this.nodes.anyButtonHolder.appendChild(btnWrapper);
    }

    highlightEditingButton(index) {
        const wrappers = this.nodes.anyButtonHolder.querySelectorAll('.anyButton__btn');

        wrappers.forEach((el, i) => {
            if (i === index) {
                el.classList.add('editing');
            } else {
                el.classList.remove('editing');
            }
        });
    }

    save() {
        return this._data;
    }

    validate(savedData) {
        return Array.isArray(savedData.buttons) && savedData.buttons.length > 0;
    }

    defaultLinkValidation(text) {
        try {
            const url = new URL(text);
            return url.protocol === "https:" || url.protocol === "http:";
        } catch {
            return false;
        }
    }

    defaultTextValidation(text) {
        return text.trim() !== "";
    }

    make(tagName, classNames = null, attributes = {}) {
        const el = document.createElement(tagName);
        if (Array.isArray(classNames)) el.classList.add(...classNames);
        else if (classNames) el.classList.add(classNames);
        Object.entries(attributes).forEach(([key, value]) => el[key] = value);
        return el;
    }
}
